import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import FontAwesomeLoader from './components/FontAwesomeLoader';
import './App.css';
import { routesByRole } from "./config/routes";
import { getRole } from "./auth/roleService";
import 'react-toastify/dist/ReactToastify.css';
import ProtectedRoute from "./auth/ProtectedRoute";
import RoleRouteGuard from "./routes/RoleRouteGuard";


// Lazy-loaded pages
const Login = lazy(() => import('./pages/auth/Login'));
const LoginTrial = lazy(() => import('./pages/auth/LoginTrial'));
const Dashboard = lazy(() => import('./pages/dashboard/Dashboard'));
const InstantRequest = lazy(() => import('./pages/seller/InstantRequest'));
const OfferDetails = lazy(() => import('./pages/seller/OfferDetails'));
const RequestDetails = lazy(() => import('./pages/buyer/RequestDetails'));
const VuexyExamples = lazy(() => import('./components/VuexyExamples'));
const VuexyComponentsDemo = lazy(() => import('./components/VuexyComponentsDemo'));

// Lazy load ToastContainer dynamically
const LazyToastContainer = lazy(() =>
  import('react-toastify').then(module => ({ default: module.ToastContainer }))
);

const App = () => {
  const role = localStorage.getItem("currentRole") || localStorage.getItem("role");;
  const roleRoutes = routesByRole[role] || [];

  const allRoutes = Object.values(routesByRole).flat();


  return (
    <Router>
      <FontAwesomeLoader />

      <div className="App">
        <Routes>

          <Route
            path="/"
            element={
              localStorage.getItem("authToken")
                ? <Navigate to="/dashboard" replace />
                : <Navigate to="/login" replace />
            }
          />
          <Route
            path="/login"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Login />
              </Suspense>
            }
          />

          <Route
            path="/login-trial"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <LoginTrial />
              </Suspense>
            }
          />

          {/* Dynamic Role Routes */}
          {allRoutes.map((route) => {
            const Component = route.component;

            return (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <ProtectedRoute>
                    <RoleRouteGuard>
                      <Suspense fallback={<div>Loading...</div>}>
                        <Component />
                      </Suspense>
                    </RoleRouteGuard>
                  </ProtectedRoute>
                }
              />
            );
          })}

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>

        {/* Lazy-loaded ToastContainer to reduce main-thread work */}
        <Suspense fallback={null}>
          <LazyToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
            draggable
            theme="light"
          />
        </Suspense>
      </div>
    </Router>
  );
};

export default App;